<template>
  <b-row>
    <b-col cols="12">
      <b-form-group label="Origem:">
        <b-form-input
          :value="origem"
          placeholder="Origem"
          :disabled="true"
        ></b-form-input> </b-form-group
    ></b-col>

    <b-col cols="12" class="border-bottom mb-4">
      <b-form-group label="Concedente:">
        <SelectConcedente
          v-model="concedente_contatos"
          :concedente_init="oportunidade.concedente"
          @changeConcedente="changeConcedente"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import SelectConcedente from "@/modules/concedentes/Components/SelectConcedente";
import { validationMixin } from "vuelidate";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  components: { SelectConcedente },

  data: () => ({}),

  validations: {
    oportunidade: {
      data_disponibilizacao: {},
    },
  },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
    origem() {
      return this.oportunidade.concedente &&
        this.oportunidade.concedente.tipo_concedente
        ? this.oportunidade.concedente.tipo_concedente.nome
        : "";
    },
    concedente_contatos: {
      set(value) {
        this.oportunidade.concedente_contatos = value;
      },
      get() {
        let response = [];
        this.oportunidade.concedente_contatos.forEach((item) => {
          if (typeof item === "number") {
            response.push(item);
          } else if (typeof item === "object") {
            response.push({id: item.id, nome: item.nome});
          }
        });
        return response;
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.oportunidade.$touch();
      return !this.$v.oportunidade.$anyError;
    },
    changeConcedente(concedente) {
      this.oportunidade.concedente_id = concedente.id;
      this.oportunidade.concedente = concedente;
    },
  },
};
</script>
